import { ProjectTag } from "../ui/project-tag";

interface ProjectInterestsCardProps {
  statusProject?: string[];
  seekingTypes?: string[];
  exhibitionWindows?: string[];
  formats?: string[];
  genres?: string[];
  subGenres?: string[];
  targetAudience?: string[];
}

export function ProjectInterestsCard({
  statusProject = [],
  seekingTypes = [],
  exhibitionWindows = [],
  formats = [],
  genres = [],
  subGenres = [],
  targetAudience = [],
}: ProjectInterestsCardProps) {
  const renderTagSection = (label: string, tags: string[]) => (
    <div className="flex flex-col gap-[10px] items-start w-full">
      <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px] w-full">
        {label}
      </p>
      <div className="flex gap-[10px] items-start flex-wrap">
        {tags.length > 0 ? (
          tags.map((tag, index) => (
            <ProjectTag key={index} label={tag} variant="primary" />
          ))
        ) : (
          <span className="text-[#888888] text-[14px]">-</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="bg-[#0C1427] rounded-[10px] p-[20px] h-[649px] w-full flex flex-col gap-[20px] items-center overflow-clip">
      <div className="flex flex-col gap-[20px] items-start w-full">
        {/* Title */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] whitespace-pre">
          Interesses e Público-Alvo
        </p>

        <div className="flex flex-col gap-[20px] items-start w-full">
          {renderTagSection("Status do projeto", statusProject)}
          {renderTagSection("Está buscando", seekingTypes)}
          {renderTagSection("Janelas de Exibição", exhibitionWindows)}
          {renderTagSection("Formato", formats)}
          {renderTagSection("Gênero", genres)}
          {renderTagSection("SubGênero", subGenres)}
          {renderTagSection("Público Alvo", targetAudience)}
        </div>
      </div>
    </div>
  );
}
